import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import { useNavigate } from 'react-router-dom';
import Icon from '@mui/material/Icon';
import config from '../../config/config.json';

const useStyles = makeStyles<Theme>((theme) => ({
  loginPrompt: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    marginTop: theme.spacing(2),
  },
  loginText: {
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  loginButtons: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  discordButton: {
    backgroundColor: '#5865F2 !important',
    '&:hover': {
      backgroundColor: '#4752C4 !important',
    },
  },
}));

interface LoginPromptProps {
  message: string;
}

export default function LoginPrompt({ message }: LoginPromptProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleDiscordLogin = () => {
    const clientId = config.discord_client_id;
    const redirectUri = `${window.location.origin}/auth/discord/callback`;
    const scope = 'identify email';

    window.location.href = `https://discord.com/api/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_type=code&scope=${encodeURIComponent(scope)}`;
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes.loginPrompt}>
          <h3 className={classes.loginText}>{message}</h3>
          <div className={classes.loginButtons}>
            <Button
              color="primary"
              style={{ minWidth: '220px' }}
              onClick={() => navigate('/login')}
            >
              {t('login.loginButton')}
            </Button>
            <Button className={classes.discordButton} onClick={handleDiscordLogin}>
              <Icon className="fab fa-discord" style={{ marginRight: '8px' }} />
              {t('login.discordButton')}
            </Button>
          </div>
        </div>
      </GridItem>
    </GridContainer>
  );
}
